import React from "react"

import "../styles/site.css"

import profilePic from '../assets/profile-pic-2021.png';

const Page = () => (
  <div className='mx-auto max-w-xl xs:mt-8 md:mt-24 lg:mt-24 p-8 flex flex-col xs:flex-row'>
    <div className='mb-8 xs:mb-0 xs:mr-8 flex-none self-center xs:self-start'>
      <img src={profilePic} alt="My profile picture" className='bg-gray-200 rounded-full w-24 h-auto' />
    </div>
    <div>
      <div>
        <h1 className='font-extrabold text-5xl leading-none tracking-tight'>Tally Tarik</h1>
        <div className='mt-4 font-bold text-sm text-gray-700 uppercase tracking-wider overflow-x-auto'>
          Senior Fullstack Developer
        </div>
        <div className='mt-0 font-bold text-sm text-gray-700 uppercase tracking-wider'>Canberra, Australia</div>
      </div>
      <div className='mt-4'>
        <div>Currently working on <a href="https://www.servicesaustralia.gov.au/" target="_blank" rel="noopener noreferrer" className="text-oblue-550 font-semibold hover:text-oblue-800 hover:no-underline">servicesaustralia.gov.au</a> for the Australian Government.</div>
      </div>
      <div className='mt-4'>
        <div className="flex -mx-2">
          <a href="https://www.linkedin.com/in/tally-tarik-b095a3121/" target="_blank" rel="noopener noreferrer" className="px-2 text-oblue-550 font-semibold hover:text-oblue-800 hover:no-underline">LinkedIn</a>
          <a href="https://twitter.com/tallytarik" target="_blank" rel="noopener noreferrer" className="px-2 text-oblue-550 font-semibold hover:text-oblue-800 hover:no-underline">Twitter</a>
          <a href="mailto:hello@tallytarik.com" className="px-2 text-oblue-550 font-semibold hover:text-oblue-800 hover:no-underline">Email</a>
        </div>
      </div>
    </div>
  </div>
);

export default Page;

export function Head() {
  return (
    <title>Tally Tarik</title>
  )
}
